import { Point } from '@ng-cloud/badger-core/models/interfaces/point';
import { Point3d } from '@ng-cloud/badger-core/models/interfaces/point3d';
import * as _ from 'lodash';
import polylabel from 'polylabel';
import intersections from 'sweepline-intersections';

export class PointUtilities {
  static isPolygonComplex(points: Point[]): boolean {
    const coordinates = _.map(points, point => [point.x, point.y]);
    coordinates.push(coordinates[0]);
    return intersections({ type: 'Polygon', coordinates: [coordinates] }, false).length > 0;
  }

  static getLabelCenter(points: Point[], precision = 1): Point {
    const center = polylabel([_.map(points, point => [point.x, point.y])], precision);
    return { x: center[0], y: center[1] };
  }

  static toPoint3dArray(flatArray: number[]) {
    const pointArray: Point3d[] = [];

    for (let i = 0; i < flatArray.length; i += 3) {
      pointArray.push({
        x: flatArray[i],
        y: flatArray[i + 1],
        z: flatArray[i + 2]
      });
    }

    return pointArray;
  }

  static toPointArray(flatArray: number[]) {
    const pointArray: Point[] = [];

    for (let i = 0; i < flatArray.length; i += 2) {
      pointArray.push({
        x: flatArray[i],
        y: flatArray[i + 1]
      });
    }

    return pointArray;
  }
}
